// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1__e0d17fecb140ea31dba7","cls2":"ImpactHubModal-cls2__bf56c65765e65775944d ImpactHubModal-cls1__e0d17fecb140ea31dba7"};